import { checkIsCompleteFit } from '@helpers/customer/fit'
import CustomerSavedFit from './CustomerSavedFit'
import useIsReactClient from '@helpers/hooks/useIsReactClient'
import NoSavedFit from './NoSavedFit'
import { getCustomerFitCondensed } from '@store/redux/selectors/customerFitSelectors'
import { useSelector } from 'react-redux'
import { useLogin } from '@api/accounts/auth/hooks/useLogin'

function AccountMyFit() {
  const { isLoggedIn } = useLogin()
  const isReactClient = useIsReactClient()
  const customerFit = useSelector(getCustomerFitCondensed)
  const savedFit = customerFit?.fit
  const hasSavedFit = savedFit && checkIsCompleteFit(savedFit)

  return (
    <>
      {hasSavedFit && isLoggedIn && isReactClient ? (
        <CustomerSavedFit savedFit={savedFit} />
      ) : (
        <NoSavedFit />
      )}
    </>
  )
}
export default AccountMyFit
